import React from "react";

export default ({ name, iconUrl, knowledgeBaseUrl }) => (
    <div>
        {iconUrl && <img src={iconUrl} className="b-table__source-icon mr-1" alt={name || ""} />}
        <span className="b-table__source-label text-muted text-nowrap">{name}</span>
        {knowledgeBaseUrl && (
            <a
                href={knowledgeBaseUrl}
                rel="noopener noreferrer"
                target="_blank"
                className="pl-1 text-decoration-none"
                onClick={(e) => e.stopPropagation()}
            >
                <i className="icon-uEA69-question-circle" />
            </a>
        )}
    </div>
);
